import { idenfitConnector } from "../../../clients";

/**
 *
 */
class Service {
  constructor() {
    this._api_connector = idenfitConnector.getClient();
  }
}

export default Service;
